"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getFilename = exports.getFileType = void 0;

var _pipe = _interopRequireDefault(require("./pipe"));

var splitFilename = function splitFilename(name) {
  return name.split(".");
};

var extractFileType = function extractFileType(splitName) {
  return splitName[splitName.length - 1];
};

var filterFileType = function filterFileType(splitName) {
  return splitName.filter(function (nameFragment) {
    return splitName.indexOf(nameFragment) !== splitName.length - 1;
  });
};
/**
 * Retrieves the file type of a given file. For example, "Happiness Survey.pdf" will
 * return "PDF".
 * @param {string} filename The full name (including a file type) of a file.
 */


var getFileType = function getFileType(filename) {
  return (0, _pipe["default"])(splitFilename, extractFileType, function (fileType) {
    return fileType.toUpperCase();
  })(filename);
};
/**
 * Retrieves the name of a file without its file type. For example, "Happiness Survey.pdf"
 * will return "Happiness Survey".
 * @param {string} filename The fill name (including a file type) of a file.
 */


exports.getFileType = getFileType;

var getFilename = function getFilename(filename) {
  return (0, _pipe["default"])(splitFilename, filterFileType, // convert the filename back to a string, re-adding any missing periods.
  function (nameFragments) {
    return nameFragments.join(".");
  })(filename);
};

exports.getFilename = getFilename;